export class County {
  countyId: number;
  regionId: number;
  countyName: string;
  state: string;

  constructor(json?: any) {
    this.countyId = json.countyId;
    this.regionId = json.regionId;
    this.countyName = json.countyName;
    this.state = json.state;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/models/County.ts